// Only laser eye surgery consultations are free.
const FREE_PATHS = new Set([
  "treatments/laser-eye-surgery",
  "treatments/laser-eye-surgery/lasik",
  "treatments/laser-eye-surgery/prk",
]);

export const FREE_LABEL = "Book a free consultation";
export const BOOKING_LABEL = "Book consultation";

export function offersFreeConsultation(pathname: string | null | undefined): boolean {
  const parts = (pathname || "/").split("/").filter(Boolean);
  const rest = parts[0] === "uk" || parts[0] === "ie" ? parts.slice(1) : parts;
  return FREE_PATHS.has(rest.join("/"));
}

// Anything phrased differently is left as the editor wrote it.
const BOOKING_PHRASE = /^book\s+(?:a\s+|your\s+)?(?:free\s+)?consultation$/i;

export function bookingLabel(label: string, free: boolean): string {
  return BOOKING_PHRASE.test(label.trim()) ? (free ? FREE_LABEL : BOOKING_LABEL) : label;
}
